import { type FieldDef, type FormFieldValue } from '../types';

export interface CompletionIssue {
  kind: 'required' | 'pattern';
  message: string;
}

const isBlank = (value: FormFieldValue) => {
  if (value === null || value === undefined) return true;
  if (typeof value === 'string') return value.trim() === '';
  if (Array.isArray(value)) return value.length === 0;
  if (typeof value === 'object') return !value.id;
  return false;
};

const matchesPattern = (pattern: string, value: string) => {
  try {
    // JSON Schema `pattern` is unanchored, as is RegExp#test.
    return new RegExp(pattern).test(value);
  } catch {
    // The backend refuses a form whose pattern doesn't compile, so an invalid
    // one here is mid-edit in the builder; don't flag answers against it.
    return true;
  }
};

// What stands between this answer and its task being marked Done: a missing
// required answer, or a non-blank answer that misses the field's pattern.
// Mirrors the backend's FormDataValidator completion rules.
const completionIssue = (field: FieldDef, value: FormFieldValue): CompletionIssue | undefined => {
  if (field.required && isBlank(value)) {
    return { kind: 'required', message: `${field.label || field.key} is required` };
  }
  if (field.pattern && typeof value === 'string' && !isBlank(value)) {
    if (!matchesPattern(field.pattern, value)) {
      return {
        kind: 'pattern',
        message: field.patternMessage || `${field.label || field.key} is not in the expected format`
      };
    }
  }
  return undefined;
};

export default completionIssue;
